import { ReportProfileOriginModel } from '../profile/report-profile-origin-model';

export class ReportProfileOriginByProderTypeModel {
  providerTypeId: string;
  origins: ReportProfileOriginModel[];
  isSucceeded: boolean|null;
}
